import { render, staticRenderFns } from "./PriceGlobalFields.vue?vue&type=template&id=029739ae&"
import script from "./PriceGlobalFields.vue?vue&type=script&lang=js&"
export * from "./PriceGlobalFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports